import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs';


export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-add3ctypeform',
  templateUrl: './add3ctypeform.component.html',
  styleUrls: ['./add3ctypeform.component.scss'] 
})

export class Add3ctypeformComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
 
  folderId:number=0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;

  OfficeIDList: any=[];
  myOfficeID: any;   
  spinner:boolean=false; 


  @Output() closeShareFile3c = new EventEmitter<boolean>();
  menuModulesList:any=[]=[];
  folderID:number=0;

 ///========== Type of particpant ==============//

 CoreShowName: string = '';
 ContactShowName: string = '';
 CompanyShowName: string = '';
 typeOfParticipant:number=0;
 emailAssigned: string = '';
 addEmailButtonShow: boolean = false;
 addUpdateParticipantList:any=[]=[];
 ShowEmailBox: boolean = true;
 ShowUserBox: boolean = false;
 ShowRoleBox: boolean = false;
 ShowCoreBox: boolean = false;
 ShowContactBox: boolean = false;
 ShowCompanyBox: boolean = false;
 CompanyList:any=[]=[];

       
 stateCtrl = new FormControl();
 filteredStates: Observable<State[]>;
 
 ShowAttchedToCore: boolean = true;
 ShowAttchedToContact: boolean = false;
 ShowAttchedToCompany: boolean = false;


 attachedToCoreList: any = [] = [];
 attachedToContactList: any = [] = [];
 attachedToCompanyList: any = [] = [];


 attachedToSelectedCore: any = [] = [];
 attachedToSelectedContact: any = [] = [];
 attachedToSelectedCompany: any = [] = [];

 checkedAttachCore: boolean = true;
 checkedAttachContact: boolean = false;
 checkedAttachCompany: boolean = false;

 CorefolderID: number = 0;
 ContactfolderID: number = 0;
 CompanyfolderID: number = 0;
 roleIdList: any = [];
 showAddButton = false;
 timeout = null;  
 selectedCoreId:number=0;
 selectedContactId:number=0;
 selectedCompanyId:number=0;

 formData: FormData;
 selectedFileArray:any=[]=[];
 selecteddocumentCategory: number = 0;
 paycheckErrorList: any = [] = [];
 isReCreate: boolean = false;
 sharedAccessRoleList: any = [] = [];
 sharedAccessUserList: any = [] = [];
 contactsList: any = [] = [];
 textNameShow:string="Email";
 moduleFrom:string="";


  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<Add3ctypeformComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    }     
  }  
  
  ngOnInit(): void {
    if(this.data)
    this.showAddButton=true;
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID = SelectedCore[0].folderID;
    }

    SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }   
    this.data;
    this.typeOfParticipant=this.data.typeOfParticipant;
    this.moduleFrom =this.data.moduleName;

    this.getTypeOfParticipants();     
  }


  typeofParticipantList:any=[]=[];

  getTypeOfParticipants() {
    var objReqModel={
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
    }
    this.settingsService.getTypeOfParticipant(objReqModel).subscribe(response => {
      if (response !== undefined) {       
        this.responseHolder = response;
        if (this.responseHolder.status === this.statusConst.statusSuccess) {
          this.typeofParticipantList= this.responseHolder.data;
          if(this.typeofParticipantList.length>0){
            this.typeofParticipantList.map((res) => {
              if (res.value==0) {
                res.icon="email";
              }
              if (res.value==1) {
                res.icon="app_registration";
              }
              if (res.value==2) {
                res.icon="contact_mail";
              }
              if (res.value==3) {
                res.icon="business";
              }
              if (res.value==4) {
                res.icon="person";
              }
              if (res.value==5) {
                res.icon="work";
              }
            });
          }  
          this.showtypeofParticipant();     
        } else {
          this.typeofParticipantList=[];
        }
      } else {
        this.typeofParticipantList=[];      
      }
    });
  }

  showtypeofParticipant(){
  // Email =0
  if(this.typeOfParticipant==0){
    this.addUpdateParticipantList=[];
    this.emailAssigned="";
    this.ShowEmailBox=true;
    this.ShowUserBox=false;
    this.ShowRoleBox=false;
    this.ShowCoreBox=false;
    this.ShowContactBox=false;
    this.ShowCompanyBox=false; 

    this.textNameShow="Email";
  }
  // User=4
  if(this.typeOfParticipant==4){
    this.addUpdateParticipantList=[];
    this.emailAssigned="";
    this.ShowEmailBox=false;
    this.ShowUserBox=true;
    this.ShowRoleBox=false;
    this.ShowCoreBox=false;
    this.ShowContactBox=false;
    this.ShowCompanyBox=false; 

    this.textNameShow="User";
  }
  // Role=5
  if(this.typeOfParticipant==5){
    this.addUpdateParticipantList=[];
    this.emailAssigned="";
    this.ShowEmailBox=false;
    this.ShowUserBox=false;
    this.ShowRoleBox=true;
    this.ShowCoreBox=false;
    this.ShowContactBox=false;
    this.ShowCompanyBox=false; 

    this.textNameShow="Role";
  }
   // Core=1
   if(this.typeOfParticipant==1){
    this.addUpdateParticipantList=[];
    this.emailAssigned="";
    this.ShowEmailBox=false;
    this.ShowUserBox=false;
    this.ShowRoleBox=false;
    this.ShowCoreBox=true;
    this.ShowContactBox=false;
    this.ShowCompanyBox=false; 

    this.textNameShow=this.CoreShowName;
  }
   // Contact=2
   if(this.typeOfParticipant==2){
    this.addUpdateParticipantList=[];
    this.emailAssigned="";
    this.ShowEmailBox=false;
    this.ShowUserBox=false;
    this.ShowRoleBox=false;
    this.ShowCoreBox=false;
    this.ShowContactBox=true;
    this.ShowCompanyBox=false; 

    this.textNameShow=this.ContactShowName;
  }
   // Company=3
   if(this.typeOfParticipant==3){
    this.addUpdateParticipantList=[];
    this.emailAssigned="";
    this.ShowEmailBox=false;
    this.ShowUserBox=false;
    this.ShowRoleBox=false;
    this.ShowCoreBox=false;
    this.ShowContactBox=false;
    this.ShowCompanyBox=true; 

    this.textNameShow=this.CompanyShowName;
  }
  }

 //======================Core============================//

  searchCore(val) {
    if (val.length >= 1) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName =val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
          if(this.moduleFrom =="Step2" || this.moduleFrom=="coredocument"){
            this.attachedToCoreList.push(
              {           
                "coreID":0,
                "name":"Create New",
                "email":"",
                "imageUrl":"",
                "isShared":false,                       
                "shortName":""
            })
          }
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }


 
  //======================Contact============================//

  searchContacts(val) {
    if (val.length >= 1) {
      this.attachedToContactList = [];
      if (val != '') {
        this.searchName =val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }

  getsearchContact(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data;
          if(this.moduleFrom =="Step2" || this.moduleFrom=="coredocument"){
            this.contactsList.push(
              {           
                "contactID":0,
                "name":"Create New",
                "email":"",
                "imageUrl":"",
                "isShared":false,                       
                "shortName":""
            })
          }
        } else {
          this.contactsList = [];
        }
      }
    })
  }


   //======================Company============================//

   searchCompany(val) {
    if (val.length >= 1) {
      this.attachedToCompanyList = [];
      if (val != '') {
        this.searchName =val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCompany(val)
        }, 500);
      } else {
        this.attachedToCompanyList = [];
      }
    }
  }

  getsearchCompany(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCCC.length > 0) {
      this.CompanyfolderID = SelectedCCC[0].folderID;
    }

    this.roleIdList = [];

    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CompanyfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCompany(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.CompanyList = response.data;
          if(this.moduleFrom =="Step2" || this.moduleFrom=="coredocument"){
            this.CompanyList.push(
              {           
                "companyID":0,
                "name":"Create New",
                "email":"",
                "imageUrl":"",
                "isShared":false,                       
                "shortName":""
            })
          }
        } else {
          this.CompanyList = [];
        }
      }
    })
  }


   //================= Role ===============================//
   getSharedAccessRoles(searchValue: any) {
    var obj={
      searchValue:searchValue,
      OrganizationID:Number(this.organizationId)
    }   
    this.settingsService.getSharedAccessRoles(obj).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessRoleList = response.data.filter((m)=>m.roleLevel==0);
        }
      }
    });
   }

   //================= User ======================//

    searchUser(val) {
       if (val.length >= 1) {
         this.sharedAccessUserList = [];
         if (val != '') {
           clearTimeout(this.timeout)
           this.timeout = setTimeout(() => {
             this.getUserListCoreImplementation(val)
           }, 500);
         } else {
           this.sharedAccessUserList = [];
         }
       }
     }
     
     getUserListCoreImplementation(searchValue: any) {
       if (searchValue == "" || searchValue == null || searchValue == undefined) {
         this.sharedAccessUserList = [];
         return;
       }
       var ReqModel = {
         DatabaseID: Number(this.databaseId),
         OrganizationID: Number(this.organizationId),
         officeID:this.myOfficeID,
         searchKey: searchValue.trim(),
         PageSize: 0,
         pageIndex: 0,
         UserID: this.currentUser.UID
       }
       this.settingsService.GetUserList(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.sharedAccessUserList = response.data.userModel;
             this.sharedAccessUserList.map((res) => {
               if (res.email != null) {
                 res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
               }
               if (res.firstName != null) {
                 res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
                 res.shortName= res.firstName.match(/\b(\w)/g).join('');
               }
               if (res.lastName != null) {
                 res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
               }
               if(res.profileImagePath==null){
                res.profileImagePath="";
               }               
               return res;
             });
             this.sharedAccessUserList = this.sharedAccessUserList;
           }
         }
       });
     }




  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);      
    }
    if(this.addUpdateParticipantList.length > 0){
      this.showAddButton=false;
    }else{
      this.showAddButton=true;
    } 
  }


  //==== For Add Email================//

  addEmail() {    
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
      var check = [];
      check = this.addUpdateParticipantList.filter(x => x.email.toLowerCase() == this.emailAssigned.toLowerCase()
      && x.typeOfParticipant==0)
  
      let toArray =  this.emailAssigned.split("@");
      var shortName = toArray[0].match(/\b(\w)/g).join('');    
      if (check.length == 0) {
        var obj={
          name: "",       
          email: this.emailAssigned,
          coreID: 0,
          contactID: 0,
          companyID:0,
          role:  0,
          userID: null,
          typeOfParticipant:0,
          img: "",
          shortName:shortName
        }
        this.addUpdateParticipantList.push(obj);      
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
        if(this.addUpdateParticipantList.length > 0){
          this.showAddButton=false;
        }else{
          this.showAddButton=true;
        } 
      } else {
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
        this.toastr.warning('Email allready added.', '', {
          timeOut: 3000,
        });
      }  
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
       this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }


  //====== For Add User ================//

  userSelectedNew(userSelected: any) {
    this.stateCtrl.setValue('');
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    var user=[];
    user = this.addUpdateParticipantList.filter(x => x.userID == userSelected.userID && x.typeOfParticipant==1);
    if (user.length==0) {   
      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
      var obj={
        name: userSelected.firstName + " " + userSelected.lastName,    
        email: userSelected.email,
        coreID: 0,
        contactID: 0,
        companyID:0,
        userID: userSelected.userID,
        typeOfParticipant:4,
        img: "",
        shortName:shortName
      }
      this.addUpdateParticipantList.push(obj);        
    }else{
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if(this.addUpdateParticipantList.length > 0){
      this.showAddButton=false;
    }else{
      this.showAddButton=true;
    } 
   
  }


   //====== For Add Role  ================//

  roleSelectedNew(roleSelected: any) {
    this.stateCtrl.setValue('');
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    var newRole=[];   
    newRole = this.addUpdateParticipantList.filter(x => x.roleID == roleSelected.roleID && x.typeOfParticipant==5);
    if (newRole.length==0) {
     
      var shortName = roleSelected.roleName.match(/\b(\w)/g).join('');
     
      var obj={
        name: roleSelected.roleName, 
        email: "",
        coreID: 0,
        contactID: 0,
        companyID:0,
        roleID:  roleSelected.roleID,
        userID: null,
        typeOfParticipant:5,
        img: "",
        shortName:shortName
      }
      this.addUpdateParticipantList.push(obj);   
      if(this.addUpdateParticipantList.length > 0){
        this.showAddButton=false;
      }else{
        this.showAddButton=true;
      } 
    }else{       
      this.toastr.warning('Role allready added.', '', {
        timeOut: 3000,
      });    
    }  
  
  }

  //====== For Add Core  ================//

  coreSelectedNew(coreSelected: any) {
    if(this.moduleFrom=="Step2" ||  this.moduleFrom=="coredocument"){
      if(coreSelected.coreID == 0) { 
        //this.dialog.closeAll();
        this.addNew('Core');
        return ;
       }
    }
  
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    // if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
    //   this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: coreSelected.name,
      email: coreSelected.email,
      coreID: coreSelected.coreID,
      contactID: 0,
      companyID:0,
      role:  0,
      userID: null,
      typeOfParticipant:1,
      img: coreSelected.imageUrl,
      shortName:shortName
    }
    this.addUpdateParticipantList.push(obj);   
    if(this.addUpdateParticipantList.length > 0){
      this.showAddButton=false;
    }else{
      this.showAddButton=true;
    } 
  } 



 //====== For Add Contact  ================//
  contactSelectedNew(contactSelected: any) {
    if(this.moduleFrom=="Step2" || this.moduleFrom=="coredocument"){
      if(contactSelected.contactID == 0) {       
        this.addNew('Contact');
        return ;
       }
    }
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    // if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
    //   this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: contactSelected.name,
      email: contactSelected.email,
      coreID: 0,
      contactID: contactSelected.contactID,
      companyID:0,
      role:  0,
      userID: null,
      typeOfParticipant:2,
      img: contactSelected.imageUrl,
      shortName:shortName
    }
    this.addUpdateParticipantList.push(obj);   
    if(this.addUpdateParticipantList.length > 0){
      this.showAddButton=false;
    }else{
      this.showAddButton=true;
    } 
  } 

  //====== For Add Company  ================//
  companySelectedNew(companySelected: any) {
   if(this.moduleFrom=="Step2" || this.moduleFrom=="coredocument"){
    if(companySelected.companyID == 0) { 
      //this.dialog.closeAll();
      this.addNew('Company');
      return ;
     }
    }
    if (this.addUpdateParticipantList.length > 0) {
      return;
    }
    // if(coreSelected.email=="" || coreSelected.email==null || coreSelected.email==undefined){
    //   this.toastr.warning('Selected '+this.contactNames+' is not added email id.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = companySelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: companySelected.name,
      email: companySelected.email,
      coreID: 0,
      contactID: 0,
      companyID: companySelected.companyID,
      role:  0,
      userID: null,
      typeOfParticipant:3,
      img: companySelected.imageUrl,
      shortName:shortName
    }
    this.addUpdateParticipantList.push(obj);   
    if(this.addUpdateParticipantList.length > 0){
      this.showAddButton=false;
    }else{
      this.showAddButton=true;
    } 
  } 

  onSelectParticpant(typeOfParticipant) {
    this.showAddButton=true;
    this.stateCtrl.setValue('');
    this.typeOfParticipant = typeOfParticipant.value;
    //== For Email =0, Core=1, Contact=1, Company=3, User=4, Role=5 ==//

     // Email =0
    if(this.typeOfParticipant==0){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=true;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow="Email";
    }
    // User=4
    if(this.typeOfParticipant==4){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=true;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow="User";
    }
    // Role=5
    if(this.typeOfParticipant==5){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=true;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow="Role";
    }
     // Core=1
     if(this.typeOfParticipant==1){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=true;
      this.ShowContactBox=false;
      this.ShowCompanyBox=false; 

      this.textNameShow=this.CoreShowName;
    }
     // Contact=2
     if(this.typeOfParticipant==2){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=true;
      this.ShowCompanyBox=false; 

      this.textNameShow=this.ContactShowName;
    }
     // Company=3
     if(this.typeOfParticipant==3){
      this.addUpdateParticipantList=[];
      this.emailAssigned="";
      this.ShowEmailBox=false;
      this.ShowUserBox=false;
      this.ShowRoleBox=false;
      this.ShowCoreBox=false;
      this.ShowContactBox=false;
      this.ShowCompanyBox=true; 

      this.textNameShow=this.CompanyShowName;
    }
  }
 
  
  onAddParticipant(){
    this.dialogRef.close(this.addUpdateParticipantList);
  }
  
  close() {
    this.dialogRef.close();
   // this.dialog.closeAll();
  }

  mainModuleName:string="";
  Module:string="";
  showAddContact:boolean = false;
  showAddCore:boolean = false;
  searchName:string='';
  isShare: boolean = false;
  sendFrom:string="TypeofParticipant"
  addNew(module) {
    this.mainModuleName = module;
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var Module = menuModulesList.filter((x) => x.mainModuleName == module);
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;
  }

  getClose(message){
    this.showAddCore = message;
  }

  saveAddNew3C(result){
    this.addUpdateParticipantList=[];

    if(this.typeOfParticipant==1){
      this.stateCtrl.setValue('');
      var shortName = "";
      shortName = result.name.match(/\b(\w)/g).join('');
      var objCore={
        name: result.name,
        email: result.email,
        coreID: result.transactionId,
        contactID: 0,
        companyID:0,
        role:  0,
        userID: null,
        typeOfParticipant:1,
        img: result.imageUrl,
        shortName:shortName
       }
      this.addUpdateParticipantList.push(objCore);  
      this.dialogRef.close(this.addUpdateParticipantList);
      // this.addUpdateParticipantList.push(objCore);   
      // if(this.addUpdateParticipantList.length > 0){
      //   this.showAddButton=false;
      // }else{
      //   this.showAddButton=true;
      // } 
    }
   
    if(this.typeOfParticipant==2){
      this.stateCtrl.setValue('');
      var shortName = "";
      shortName = result.name.match(/\b(\w)/g).join('');
      var objContact={
        name: result.name,
        email: result.email,
        coreID: 0,
        contactID:result.transactionId,
        companyID:0,
        role:  0,
        userID: null,
        typeOfParticipant:2,
        img: result.imageUrl,
        shortName:shortName
      }
      this.addUpdateParticipantList.push(objContact);  
      this.dialogRef.close(this.addUpdateParticipantList);
      // this.addUpdateParticipantList.push(objContact);   
      // if(this.addUpdateParticipantList.length > 0){
      //   this.showAddButton=false;
      // }else{
      //   this.showAddButton=true;
      // } 
    }

    if(this.typeOfParticipant==3){
      this.stateCtrl.setValue('');
      var shortName = "";
      shortName = result.name.match(/\b(\w)/g).join('');
      var objCompany={
        name: result.name,
        email: result.email,
        coreID: 0,
        contactID: 0,
        companyID:result.transactionId,
        role:  0,
        userID: null,
        typeOfParticipant:3,
        img: result.imageUrl,
        shortName:shortName
      }
      this.addUpdateParticipantList.push(objCompany);  
      this.dialogRef.close(this.addUpdateParticipantList);
      // this.dialogRef.close(objCompany);
      // this.addUpdateParticipantList.push(objCompany);   
      // if(this.addUpdateParticipantList.length > 0){
      //   this.showAddButton=false;
      // }else{
      //   this.showAddButton=true;
      // } 
    }

    // this.addUpdateParticipantList.push({
    //     name: "",
    //     email: "",
    //     img: "",
    //     contactID: result,
    //     roleID: 0,
    //     isShared: this.isShare,
    //     shortName: "",
    //   });
    //   this.dialogRef.close(this.addUpdateParticipantList);
      //this.addUpdateParticipants();
    }

}
